
import axios from 'axios'

export default async() => {
    const response = await axios.get(`/reward-platform`)
    return response.data
}